﻿define([
    'jquery',
    'pubsub',
    'generalUtilities',
    'agentsSearchUtilities',
    'moduleUtilities',
    'Handlebars',
    'text!agentsSearchFormTemplate',
    'text!agentsSearchLanguageSpokenPartial',
    'languageSpokenData',
    'addressUtility',
    'userSearchService',
    'groupService',
    'jquery.ui',
    'locationAutoCompleteControl',
    'mixpanelControl',
    'userGeolocationControl',
    'qtipLib'
], function agentsSearchLocationControl(
    $,
    pubsub,
    generalUtilities,
    agentsSearchUtilities,
    moduleUtilities,
    Handlebars,
    agentsSearchFormTemplate,
    agentsSearchLanguageSpokenPartial,
    languageSpokenGeneralData
) {
    // set up
    // -------------------------------------------

    'use strict';

    var module, selectors, values, qTipConfig, elements;

    module = {};
    module.private = {};
    module.properties = {};

    qTipConfig = {
        keyWordToolTip: {
            selector: '.js-keyword-tooltip',
            text: RESAAS.Localization.UserSearch.USER_SEARCH_KEYWORDS_TOOLTIP
        },
        FirmToolTip: {
            selector: '.js-firm-tooltip',
            text: RESAAS.Localization.UserSearch.TIP_ENTER_AT_LEAST_THREE_CHARS
        },
        YearOfExpToolTip: {
            selector: '.js-yearsofexp-tooltip',
            text: RESAAS.Localization.UserSearch.USER_SEARCH_YEARS_OF_EXPERIENCE_TOOLTIP
        }
    };

    selectors = {};
    elements = {};

    selectors.searchFormContainer = '.js-usersearch-search-inner';
    selectors.searchForm = '.js-usersearch-form';
    selectors.searchInputs = '.js-usersearch-input';
    selectors.searchFormSubmit = '.js-usersearch-submit';
    selectors.searchLocationInput = '.js-usersearch-location-input';
    selectors.searchLocationButton = '.js-usersearch-location-btn';
    selectors.searchFormResetBtn = '.js-usersearch-reset-btn';
    selectors.distanceInput = '.js-distance-input';
    selectors.usersearchnearmebtn = '.js-usersearchnearme-btn';
    selectors.usersearchmyfirmbtn = '.js-usersearchmyfirm-btn';
    selectors.distanceConatiner = '.js-distance-container';

    values = {};
    values.geoCodeTimeout = 3000;
    Handlebars.registerPartial('agentsSearchLanguageSpokenPartial', agentsSearchLanguageSpokenPartial);
    values.agentsSearchFormHtml = Handlebars.compile(agentsSearchFormTemplate);

    // utilities
    // -------------------------------------------

    module.private.bindqTip = function bindqTip() {
        $.each(qTipConfig, function qTipConfigFunc(key, value) {
            $(value.selector).qtip({
                content: {
                    text: value.text
                },
                position: {
                    my: 'bottom center',
                    at: 'top center',
                    target: $(value.selector),
                    viewport: $(window),
                    adjust: {
                        method: 'shift shift'
                    }
                },
                hide: {
                    event: 'click'
                },
                show: {
                    event: 'click',
                    solo: true
                },
                style: {
                    def: false,
                    classes: 're-qtip-white',
                    tip: {
                        corner: 'bottom center',
                        width: 20,
                        height: 10,
                        border: 1
                    }
                },
                events: {
                    render: function eventsRender(event, api) {
                        elements.body.on('click', function eventsRenderBodyClick() {
                            $(api.elements.tooltip).hide();
                        });
                    }
                }
            });
        });
    };

    module.private.getDeepLink = function getDeepLink(location) {
        var obj, deepLinkPath, deepLinkQuery;
        deepLinkPath = module.private.getDeepLinkPath(location.pathname);
        deepLinkQuery = module.private.getDeepLinkQuery(location.search);

        if ((deepLinkQuery._subjectType === 'firm' || deepLinkQuery._subjectType === 'group') && deepLinkQuery._subject) {
            deepLinkQuery.RelationshipSearch = deepLinkQuery._subject;
        }

        // default user location if there is no query parameters and path not include group and firm.
        if (Object.keys(deepLinkQuery).length === 0 && deepLinkPath._subjectType !== 'group' && deepLinkPath._subjectType !== 'firm' && generalUtilities.prop(window, 'RESAAS.Environment.Experience') !== 'commercial') {
            deepLinkPath.defaultUserLocation = true;
        }

        obj = $.extend(deepLinkPath, deepLinkQuery);

        obj._subjectName = obj._subjectName ? decodeURIComponent(obj._subjectName) : obj._subject;
        obj._locationName = obj._locationName ? decodeURIComponent(obj._locationName) : null;

        obj.Name = obj.Name ? decodeURIComponent(obj.Name) : null;
 
        return obj;
    };

    module.private.getDeepLinkPath = function getDeepLinkPath(pathname) {
        var obj, pathArray;
        obj = {
            _show: null,
            _type: null,
            _subject: null,
            _subjectType: null
        };

        pathArray = pathname.split('/');

        // get type
        obj._type = pathArray[2];

        switch (obj._type) {
            case 'group':
                obj._show = 'all';
                obj._subjectType = 'group';
                obj._subject = pathArray[3];
                obj.RelationshipSearch = pathArray[3];
                break;
            case 'firm':
                obj._show = 'all';
                obj._subjectType = 'firm';
                obj._subject = pathArray[3];
                obj.RelationshipSearch = pathArray[3];
                break;
            case 'location':
                obj._show = 'all';
                // get city from path and capitalize first letter
                obj._locationName = pathArray[3][0].toUpperCase() + pathArray[3].slice(1);
                // if state is in path, add it to location name
                if (pathArray.length > 4) {
                    if (pathArray[4] !== '') {
                        obj._locationName = obj._locationName + ', ' + pathArray[4].toUpperCase();
                    }
                }
                break;
            case 'country':
                obj.CountryCode = pathArray[3];
                obj.SearchType = 1;
                break;
            default:
            // do nothing
        }

        return obj;
    };

    module.private.getDeepLinkQuery = function getDeepLinkQuery(query) {
        if (typeof query === 'string') {
            return generalUtilities.queryStringToObject(query);
        }

        return {};
    };


    module.private.renderForm = function renderForm(data) {
        var $html, formData, allLanguageSpokenList, languagesSpoken;

        var experience = generalUtilities.prop(window, 'RESAAS.Environment.Experience');
        var firmId = generalUtilities.prop(window, 'RESAAS.User2.FirmId');
        var firmName = generalUtilities.prop(window, 'RESAAS.User2.FirmName');

        var isExperienced = experience && experience !== 'resaas' && experience !== 'commercial';

        formData = {};
        formData = $.extend({}, data);
        formData.useMiles = RESAAS.User2.CountryId === 224;
        allLanguageSpokenList = languageSpokenGeneralData.browse();

        if (formData.LanguagesSpoken){
            languagesSpoken = decodeURIComponent(formData.LanguagesSpoken);
            allLanguageSpokenList.forEach(function check(element) { if (languagesSpoken.indexOf(element.value) !== -1) { element.checked = true } else { element.checked = false } });
        }

        if (generalUtilities.prop(window, 'RESAAS.User2.UserId')){
            formData.userAuthorized = true;
        }

        if (experience === 'commercial') {
            formData.isCommercial = true;
        }

        if (isExperienced) {
            formData.hasExperience = true;
            formData.RelationshipSearch = formData.RelationshipSearch ? formData.RelationshipSearch : 1;
            if (firmId) {
                formData.hasFirmWithExperience = true;
                formData.FirmLabel = firmName + ' Agents Only';
            }
        } else {
            formData.RelationshipSearch = formData.RelationshipSearch ? formData.RelationshipSearch : 0;
            if (firmId) {
                formData.hasFirm = true;
                formData.FirmLabel = firmName + ' Agents Only';
            }
        }

        // default user location
        if (formData.defaultUserLocation && generalUtilities.prop(window, 'RESAAS.User2.Longitude') && generalUtilities.prop(window, 'RESAAS.User2.Latitude')) {
            formData.Longitude = RESAAS.User2.Longitude;
            formData.Latitude = RESAAS.User2.Latitude;
            formData._locationName = agentsSearchUtilities.getUserLocation(RESAAS.User2);
            formData.CountryCode = generalUtilities.prop(window, 'RESAAS.User2.CountryId');
        }

        formData.topLanguageSpokenList = allLanguageSpokenList.slice(0, 5);
        formData.restLanguageSpokenList = allLanguageSpokenList.slice(5);

        $html = values.agentsSearchFormHtml(formData);
        $(selectors.searchFormContainer).html($html);

        // expand the search relationship toggle
        if (formData._subject) {
            pubsub.publish('accordionControl.expand', { selector: '.re-usersearch-relationship' });
        }

        if (formData.Longitude && formData.Latitude) {
            agentsSearchUtilities.renderDistanceDropDown(true);
        } else {
            agentsSearchUtilities.renderDistanceDropDown(false);
        }

        //tooltip
        module.private.bindqTip();
    };

    module.private.handleSearchFormSubmit = function handleSearchFormSubmit(e) {
        e.preventDefault();
    };

    module.private.handleNearMeBtn = function handleNearMeBtn(e) {
        module.private.handleResetForm(e);
        $('#all').click();
        $('.js-usergeolocation-btn').click();
    };

    module.private.handleMyFirmBtn = function handleMyFirmBtn(e) {
        module.private.handleResetForm(e);
        $('#myfirm').click();
    };

    module.private.handleResetForm = function handleResetForm(e) {
        e.preventDefault();
        generalUtilities.disableAndWaitFor(selectors.searchFormResetBtn, 'dataUserSearchBrowse');
        $('input[type="text"]').val('');
        $('input[type="hidden"]').val('');
        $('input[type="number"]').val('');
        $('[name="YearsOfExperience"]').prop('selectedIndex', 0);
        $('[name="LanguagesSpoken"]:checked').each(function languageSpokenEach() {
            this.checked = false;
        });
        $('[name="RelationshipSearch"]:checked').each(function relationshipsSearchEach() {
            this.checked = false;
        });
        $('#all').prop('checked', 'checked');
        agentsSearchUtilities.renderDistanceDropDown(false);
        window.history.replaceState(null, 'Agents', '/agents');
        agentsSearchUtilities.doSearch();
        pubsub.publish('mixpanel.Intent', { type: 'reset button user discovery', from: window.pageType });

    };

    module.private.handleClickApply = function handleClickApply() {
        agentsSearchUtilities.doSearch();
        pubsub.publish('mixpanel.Intent', { type: 'apply button user discovery', from: window.pageType });
    };

    module.private.handleDistanceInputChange = function handleDistanceInputChange() {
        agentsSearchUtilities.doSearch();
    }
    module.private.renderPage = function renderPage(params) {

        // render form
        module.private.renderForm(params);

        // bind google autocomplete to location input
        agentsSearchUtilities.setUpLocationAutocomplete();

        // do search
        agentsSearchUtilities.doSearch('deeplink');

        pubsub.publish('accordionControl.bind', {
            selector: '.js-userview-toggles'
        });

    }
    module.private.handleDataGetUserGroupsAll = function handleDataGetUserGroupsAll(e, data) {
        var params, groupList,group;
        var topGroupList = [];
        var bottomGroupList = [];
        // get deep link values
        params = module.private.getDeepLink(window.location);
        if (generalUtilities.prop(data, 'response.status') || generalUtilities.prop(data, 'response.statusText')) {
            pubsub.publish('loggly.error', {
                message: generalUtilities.stringFormat(
                    'fetch groups that user belongs to: {0}',
                    JSON.stringify(data)
                )
            });
        } else {
            groupList = generalUtilities.prop(data, 'response').filter(function (g) {
                return g.UniqueName !== "local-feed" && g.FirmGroupType === 1;
            });
            
            // Add the searched firm/group to the groupList if the group not exist in the list
            if (params._subjectName && params._subject) {

                var index = groupList.findIndex(function findIndex(group) {
                    return group.UniqueName === params._subject;
                });

                // If the group exists -> remove it from its current position
                if (index !== -1) {
                    group = groupList[index];
                    groupList.splice(index, 1);
                } else {
                    group = { GroupName: params._subjectName, UniqueName: params._subject, SearchType: params._subjectType }
                }

                // Add the group to the top of the list
                groupList.unshift(group);
            }

            // more than 2 group
            if (groupList.length > 2) {
                topGroupList = groupList.slice(0, 2);
                bottomGroupList = groupList.slice(2);
            } else {
                topGroupList = groupList;
            }

            params.topGroupList = topGroupList;
            params.bottomGroupList = bottomGroupList;    
        }
        module.private.renderPage(params);
    }

    module.private.getUserGroupsAll = function getUserGroupsAll() {
        var requestOptions = {};
        var request = {};
        var serviceObject = moduleUtilities.createServiceObject(request, module.properties, requestOptions);
        pubsub.publish('uiNeeds.GetUserGroupsAll', serviceObject);
    };

    module.private.init = function init(e, data) {
        // set values
        var params;

        module.properties.guid = data && data.guid ? data.guid : generalUtilities.uuid();
        elements.body = $('body');

        if (generalUtilities.prop(window, 'RESAAS.User2.UserId')) {
            module.private.getUserGroupsAll();
        } else {
            // get deep link values
            params = module.private.getDeepLink(window.location);
            module.private.renderPage(params);
        }
    };

    // event bindings
    // -------------------------------------------

    $('body').on('submit', selectors.searchForm, module.private.handleSearchFormSubmit);
    agentsSearchUtilities.bindHandleFieldChanged();
    $('body').on('click', selectors.searchFormResetBtn, module.private.handleResetForm);
    $('body').on('click', selectors.searchFormSubmit, module.private.handleClickApply);
    $('body').on('change', selectors.distanceInput, module.private.handleDistanceInputChange);
    $('body').on('click', selectors.usersearchnearmebtn, module.private.handleNearMeBtn);
    $('body').on('click', selectors.usersearchmyfirmbtn, module.private.handleMyFirmBtn);
    // external event bindings
    // -------------------------------------------

    pubsub.subscribe('uiWantsAgentsSearchControlInit', module.private.init);
    pubsub.subscribe('data.GetUserGroupsAll', module.private.handleDataGetUserGroupsAll)
    agentsSearchUtilities.bindhandleDataUserLocationBrowse();

    // expose API
    // -------------------------------------------
    return module;
});
